import { TextField } from '@mui/material'
import { DatePicker, DateTimePicker, LocalizationProvider, PickersActionBarAction } from '@mui/x-date-pickers-pro'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import React, { useRef } from 'react'

import { removeSeconds, stringToZonedDateTime, ZonedDateTimeToJSON } from 'src/commons/temporalHelpers'
import { getDayjsValue } from 'src/muiv5/components/commons/SidePanel/Filters/TimeRangeFilter/utils'

interface IProps {
  clearable?: boolean
  disableFuture?: boolean
  disabled?: boolean
  error?: boolean
  label?: string
  maxDate?: Temporal.ZonedDateTime
  maxDateMessage?: string
  minDate?: Temporal.ZonedDateTime
  onChange: (date?: Temporal.ZonedDateTime) => void
  sx?: { [key: string]: number }
  value?: Temporal.ZonedDateTime
  withTime?: boolean
}

const SimpleDatePicker = (props: IProps) => {
  const {
    value,
    onChange,
    disableFuture,
    clearable,
    label,
    minDate,
    maxDate,
    error,
    withTime,
    disabled,
    maxDateMessage,
    sx,
  } = props

  const pickerRef = useRef(null)

  const onDateChange = (date: dayjs.Dayjs | null) => {
    let dateTime = undefined
    if (date !== null) {
      const t = stringToZonedDateTime(date.format())
      dateTime = withTime ? removeSeconds(t) : t.startOfDay()
    }
    onChange(dateTime)
  }

  const pickerProps = {
    value: getDayjsValue(value),
    onChange: onDateChange,
    maxDateMessage: maxDateMessage,
    disableFuture,
    clearable,
    label,
    minDate: minDate ? dayjs(ZonedDateTimeToJSON(minDate)) : undefined,
    maxDate: maxDate ? dayjs(ZonedDateTimeToJSON(maxDate)) : undefined,
    error,
    disabled,
  }

  const onKeyDown = (e: React.KeyboardEvent) => {
    e.preventDefault()
  }

  const actions: PickersActionBarAction[] = []
  if (props.clearable) {
    actions.push('clear')
  }
  actions.push('cancel')
  actions.push('accept')

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={dayjs.locale()}>
      <div ref={pickerRef} />
      {withTime ? (
        <DateTimePicker
          {...pickerProps}
          format={'L LT'}
          slots={{
            textField: (props) => <TextField onKeyDown={onKeyDown} {...props} />,
          }}
          slotProps={{
            actionBar: {
              actions: actions,
            },
            popper: { anchorEl: pickerRef.current },
          }}
          sx={sx}
        />
      ) : (
        <DatePicker {...pickerProps} format={'L'} sx={sx} />
      )}
    </LocalizationProvider>
  )
}

export default SimpleDatePicker
